import "./BenefitItem.scss";

export interface BenefitItemProps {
  benefitsTitle: string;
  benefitsImage: string;
}

const BenefitItem = ({ benefitsTitle, benefitsImage }: BenefitItemProps) => {
  return (
    <div className={"benefitItem"}>
      <img className={"benefitItem__image"} src={benefitsImage} alt="benefit image" />
      <div className={"benefitItem__title"}>{benefitsTitle}</div>
    </div>
  );
};

export default BenefitItem;
